var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_186_6487)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    transform: "matrix(-1 0 0 1 50 10)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2252 15.7748C46.666 18.2155 46.666 22.1439 46.666 30.0007C46.666 37.8573 46.666 41.7858 44.2252 44.2265C41.7845 46.6673 37.8561 46.6673 29.9993 46.6673C22.1427 46.6673 18.2142 46.6673 15.7735 44.2265C13.3327 41.7858 13.3327 37.8573 13.3327 30.0007C13.3327 22.1439 13.3327 18.2155 15.7735 15.7748C18.2142 13.334 22.1427 13.334 29.9993 13.334C37.8561 13.334 41.7845 13.334 44.2252 15.7748ZM27.916 21.6673C27.916 22.3577 27.3563 22.9173 26.666 22.9173H24.6838L28.3832 26.6168C28.8713 27.105 28.8713 27.8963 28.3832 28.3845C27.895 28.8727 27.1037 28.8727 26.6155 28.3845L22.916 24.6851V26.6673C22.916 27.3577 22.3563 27.9173 21.666 27.9173C20.9757 27.9173 20.416 27.3577 20.416 26.6673V21.6673C20.416 20.977 20.9757 20.4173 21.666 20.4173H26.666C27.3563 20.4173 27.916 20.977 27.916 21.6673ZM31.6155 33.3845C31.1273 32.8963 31.1273 32.105 31.6155 31.6168C32.1037 31.1287 32.895 31.1287 33.3832 31.6168L37.0827 35.3162V33.334C37.0827 32.6437 37.6423 32.084 38.3327 32.084C39.023 32.084 39.5827 32.6437 39.5827 33.334V38.334C39.5827 39.0243 39.023 39.584 38.3327 39.584H33.3327C32.6423 39.584 32.0827 39.0243 32.0827 38.334C32.0827 37.6437 32.6423 37.084 33.3327 37.084H35.3149L31.6155 33.3845Z",
    fill: "#008787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_186_6487",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.529412 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_186_6487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_186_6487",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.5fb8092dee40e1215e33497557ec12b3.svg";
export { ForwardRef as ReactComponent };